<ng-container *ngIf="user$ | async as u">
  <mat-drawer-container class="sidenav" [hasBackdrop]="true" autosize>
    <mat-drawer #drawer [mode]="'side'" class="example-sidenav" mode="side">
      <div class="sidenav__menu" cdkMenu>
        <button class="sidenav__menu__item" cdkMenuItem [routerLink]="'/'" (click)="drawer.toggle()">Inicio</button>
        <button *ngIf="u?.role === 'ADMINISTRADOR'" [routerLink]="'/depreciation'" (click)="drawer.toggle()" class="sidenav__menu__item" cdkMenuItem>Depreciación</button>
        <button class="sidenav__menu__item" cdkMenuItem [cdkMenuTriggerFor]="warranty">Garantía</button>
        <button *ngIf="u?.role === 'ADMINISTRADOR'" class="sidenav__menu__item" cdkMenuItem [cdkMenuTriggerFor]="maintainer">Mantenedor</button>
      </div>
    </mat-drawer>

    <div class="sidenav__trigger">
      <button *ngIf="u?.status === 'ACTIVO'" (click)="drawer.toggle()" type="button" mat-button class="sidenav__trigger__toggle">
        <mat-icon [color]="'primary'" [inline]="true" fontIcon="menu" class="sidenav__trigger__toggle--icon"></mat-icon>
      </button>
    </div>

    <ng-content></ng-content>
  </mat-drawer-container>



  <ng-template #warranty>
    <div class="sidenav__menu" cdkMenu>
      <button [routerLink]="'/warranty/recovery'" [queryParams]="{ tab: 'INFO' }" (click)="drawer.toggle()" class="sidenav__menu__item" cdkMenuItem>Panel informativo</button>
      <button [routerLink]="'/warranty/recovery'" [queryParams]="{ tab: 'REPORTS' }" disabled class="sidenav__menu__item" cdkMenuItem>Reportes</button>
      <!--    <hr />-->
      <!--    <button class="sidenav__menu__item" cdkMenuItem>Otros</button>-->
    </div>
  </ng-template>

  <ng-template #maintainer>
    <div class="sidenav__menu" cdkMenu>
      <button cdkMenuItem [cdkMenuTriggerFor]="users" class="sidenav__menu__item">Usuarios</button>
      <hr />
      <button disabled class="sidenav__menu__item" cdkMenuItem>Roles</button>
      <hr />
      <button disabled class="sidenav__menu__item" cdkMenuItem>Casos</button>
    </div>
  </ng-template>

  <ng-template #users>
    <div class="sidenav__menu" cdkMenu>
      <button [routerLink]="'/maintainer/users'" [queryParams]="{ tab: 'NEW_USER' }" (click)="drawer.toggle()" class="sidenav__menu__item" cdkMenuItem>Nuevo ingreso</button>
      <button [routerLink]="'/maintainer/users'" [queryParams]="{ tab: 'EDIT_USERS' }" (click)="drawer.toggle()" class="sidenav__menu__item" cdkMenuItem>Usuarios creados</button>
    </div>
  </ng-template>
</ng-container>
